module.exports = __webpack_public_path__ + "static/media/falle.11a34000.m4a";